import { ReactNode } from "react";
import { useDispatch } from "react-redux";
import { loginActions } from "../../pages/LoginPage/reducer";
import { getParamsWeatherOfOp } from "../../pages/PlanOperationPage/util";
import { OpService } from "../../util/services/operation";
import { VesselSideService } from "../../util/services/vessel-side";
import { getStore } from "../../util/store/store";
import { STEP_STATUS } from "../../util/varibles/constants";
import { getPauseState, showErrorResponse } from "../../util/varibles/global";
import { IActivityLog, IOperation2, TOperation2 } from "../../util/varibles/interface";
import { createFastContext } from "../createFastContext2";

export const getStepId = (log: IActivityLog, index: number) => `${log.key}_${index}`;

export const state: { [id: string]: string } = {
    [STEP_STATUS.NOT_START]: 'start',
    [STEP_STATUS.STARTED]: 'finish',
}

export interface INextStatePayload {
    group_ids?: string[],
    crew_task_id?: string,
    state?: string | number,
    step_state?: string | number,
    step_new?: number,
    index?: number
    unit_id?: string
    round_no?: string
    keys?: string[]
    movement_type?: string
    loading?: boolean | string
    group_map?: {
        tank_id: string
        unit_id?: string
        delivery_type_id?: string
        dead_fish?: number
        fish_amount?: number
        total_weight?: number
        group_id: string
    }[]
    current_process?: number
}

interface IState {
    op?: IOperation2
    active?: boolean
    loading: boolean | string
    weather?: {
        loading: boolean
        data?: {
            weather: any
            typical_condition: number
        }
    }
    step: number
    stepStates: { [index_and_stepKey: string]: { state: number } }
    pause: number

    onUpdate(value: IOperation2): void
    onExtend?(): void
}

const {
    Provider,
    useStore: useTrackingOp,
    setStore: setTrackingOp,
    getStore: getTrackingOp,
    callEvent: callEventTrackingOp
} = createFastContext<IState, {
    nextState: (props: INextStatePayload) => void,
    getWeather: () => void
}>({
    step: 0,
    loading: false,
    stepStates: {},
    pause: -1,
    onUpdate: () => null
});

const TrackingOpProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    const dispatch = useDispatch();
    const { current_process } = args.op?.operation || {};

    return <Provider
        event={{
            nextState: (payload, { get, set }) => {
                const { op, loading } = get();
                const { step_new, loading: loadingValue = true, ...real_payload } = payload;
                if (!op || loading)
                    return;
                const { id = '', tenant_id = '', checklists_v2 = [], vessel_id = '' } = op.operation || {};
                const body = {
                    operation_id: id,
                    tenant_id,
                    vessel_id,
                    checklists_v2,
                    ...real_payload,
                };
                set({ loading: loadingValue })
                VesselSideService.updateState(body)
                    .then(({ operation, activity_log }) => {
                        set({ loading: false })

                        const operationNew = { ...op, activity_log, operation: { ...op.operation, ...operation } } as IOperation2;
                        dispatch(loginActions.updateOpOfVessel(operationNew));
                        setTimeout(() => {
                            set(({ step: prevStep }) => {
                                if (step_new !== undefined) {
                                    if (step_new === -1)
                                        return { step: prevStep + 1 }
                                    return { step: step_new }
                                }
                                return {}
                            })
                        }, 100)
                        if (args.onUpdate)
                            args.onUpdate(operationNew)
                    })
                    .catch(error => {
                        showErrorResponse("Error", error);
                        set({ loading: false })
                    })
            },
            getWeather: ({ get, set }) => {
                const { op } = get();
                if (!op)
                    return;
                const { operation, activity_log, vessel } = op;
                const { tenant_id, operation_type } = operation;
                set({ weather: { loading: true, data: undefined } })
                const params = getParamsWeatherOfOp(operation as TOperation2, { operation_type, tenant_id, activity_log });
                OpService.getWeather(params)
                    .then((rs: any) => {
                        set({ weather: { loading: false, data: rs, } })
                    })
                    .catch((error: any) => {
                        set({ weather: { loading: false, data: undefined, } })
                        showErrorResponse('Get weather failed', error);
                    })

                const { weather } = getStore().login;
                if (!weather?.[vessel.id]) {
                    const { id, tenant_id } = operation;
                    OpService.getWeatherLive({ id, tenant_id }).then(rs => {
                        dispatch(loginActions.updateWeather({ vesselId: vessel.id, value: rs.weather }))
                    })
                }
            }
        }}
        props={{ ...args, step: current_process, pause: args.op ? getPauseState(args.op.operation).activePauseIndex : -1 }}
    >
        {children}
    </Provider>
}


export { callEventTrackingOp, getTrackingOp, setTrackingOp, TrackingOpProvider, useTrackingOp };
